import { create } from "zustand";
import {
  InstructorRemovalFlowContext,
  InstructorRemovalFlowStatus,
  InstructorRemovalReason,
  InstructorRemovalSnapshot,
} from "./types";

interface InstructorRemovalFlowState {
  status: InstructorRemovalFlowStatus;
  context: InstructorRemovalFlowContext | null;
  beforeSnapshot: InstructorRemovalSnapshot | null;
  afterSnapshot: InstructorRemovalSnapshot | null;
  reasons: InstructorRemovalReason[];
  pendingReplacement: boolean;
}

const INITIAL_STATE: InstructorRemovalFlowState = {
  status: "idle",
  context: null,
  beforeSnapshot: null,
  afterSnapshot: null,
  reasons: [],
  pendingReplacement: false,
};

export const useInstructorRemovalFlowStore = create<InstructorRemovalFlowState>(() => ({
  ...INITIAL_STATE,
}));

export const isSameInstructorRemovalContext = (
  first?: InstructorRemovalFlowContext | null,
  second?: InstructorRemovalFlowContext | null,
) =>
  !!first &&
  !!second &&
  first.workspaceId === second.workspaceId &&
  first.scenarioId === second.scenarioId &&
  first.originId === second.originId &&
  first.linkId === second.linkId;

export const beginInstructorRemovalVerification = (
  context: InstructorRemovalFlowContext,
  pendingReplacement: boolean,
) => {
  useInstructorRemovalFlowStore.setState({
    ...INITIAL_STATE,
    status: "preparing-snapshot",
    context,
    pendingReplacement,
  });
};

export const setInstructorRemovalFlowState = (state: Partial<InstructorRemovalFlowState>) => {
  useInstructorRemovalFlowStore.setState(state);
};

export const resetInstructorRemovalFlow = () => {
  useInstructorRemovalFlowStore.setState({ ...INITIAL_STATE });
};
